export default {
  UPDATE_VEHICLE_LIST: 'UPDATE_VEHICLE_LIST',
  UPDATE_SELECTED_VEHICLE: 'UPDATE_SELECTED_VEHICLE',
  UPDATE_VEHICLE_RECORDS: 'UPDATE_VEHICLE_RECORDS',
  UPDATE_VEHICLE_STATISTICS: 'UPDATE_VEHICLE_STATISTICS',
};
